module.exports = __webpack_public_path__ + "img/logo.fa661f7f.svg";